import styled from "styled-components";
import { ReactComponent as EliteDealsBadge } from "assets/elite-deals/badge.svg";

export const Container = styled("div")`
	font-size: 0.75em;
	position: absolute;
	top: 3.7em;
	right: 1em;
	width: 5.5em;
	height: 5.5em;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	//transform: rotate(-21deg);
	color: #fff;
	font-family: "Baloo";

	-webkit-text-stroke-width: 0.28em;
	-webkit-text-stroke-color: #000;
	paint-order: stroke fill;

	animation: scalerotate 2s infinite;

	@keyframes scalerotate {
		0% {
			transform: scale(1) rotate(-30deg);
		}
		50% {
			transform: scale(1.1) rotate(-20deg);
		}
		100% {
			transform: scale(1) rotate(-30deg);
		}
	}

	@media (orientation: landscape) {
		top: 6em;
		right: 0.4em;
		width: 5em;
		height: 5em;
	}
`;

export const Badge = styled(EliteDealsBadge)<{
	$color: string;
	$borderColor: string;
}>`
	position: absolute;
	inset: 0;
	width: 100%;
	height: 100%;
	pointer-events: none;

	#fillPath {
		fill: ${(props) => props.$color};
	}

	#strokePath {
		stroke: ${(props) => props.$borderColor};
	}
`;

export const Text = styled.span`
	margin-bottom: 0.5em;
	position: relative;

	span {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		opacity: 1;
		//animation: fadeInText 4s infinite;
	}

	span.text {
		font-size: 1.3em;
		line-height: 0.8em;
	}

	span.text2 {
		font-size: 1.3em;
		line-height: 0.8em;
		animation-delay: 2s;
	}

	@keyframes fadeInText {
		0% {
			opacity: 0;
		}
		50% {
			opacity: 0;
		}
		75% {
			opacity: 1;
		}
		100% {
			opacity: 0;
		}
	}
`;
